/* JCI: Native dialog keeps keyboard focus contained; listeners are removed on editor unload. */
window.JCIHome.register('hero', (root, on, cleanup) => {
  const dialog = root.querySelector('.care-dialog');
  if (!dialog) return;
  let opener;
  on(document, 'click', event => {
    const button = event.target.closest('[data-open-care], a[href="#personal-care"]');
    if (!button || !dialog) return;
    event.preventDefault(); opener = button; dialog.showModal(); document.body.classList.add('modal-open');
  });
  on(dialog.querySelector('.close-care-dialog'), 'click', () => dialog.close());
  on(dialog, 'click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  on(dialog, 'close', () => { document.body.classList.remove('modal-open'); opener?.focus(); });
  const image = dialog.querySelector('.care-gallery > img');
  const buttons = [...dialog.querySelectorAll('.gallery-controls button')];
  buttons.forEach(button => on(button, 'click', () => {
    const thumbnail = button.querySelector('img'); image.src = thumbnail.currentSrc || thumbnail.src; image.removeAttribute('srcset'); image.alt = button.dataset.alt;
    buttons.forEach(b => { b.classList.toggle('selected', b === button); b.setAttribute('aria-pressed', String(b === button)); });
  }));
  cleanup(() => { if (dialog.open) dialog.close(); document.body.classList.remove('modal-open'); });
});
